export type SearchParamsType = {
  pageNumber: number;
  pageSize: number;
  sortField: string;
  sortOrder: string;
  filter:{
    search:string
    status:number
  }
};

export type MasterTableDataType = {
  typeName: string;
  id: number;
  description: string;
  status: number;
  clinicId: number;
  createdById: number;
  createdDate: string; // Format: "YYYY-MM-DD HH:mm:ss.s"
  ministry: string;
};


export type MasterDataType = {
  insuranceTypeId: number|null;
  insuranceTypeClinicId: number;
  insuranceTypeCreatedByDate: string; // ISO date string
  insuranceTypeCreatedById: number;
  insuranceTypeDescription: string;
  insuranceTypeMinistryName: string;
  insuranceTypeName: string;
  insuranceTypeStatus: number;
};



export type SaveResponseType = {};

export type MasterFormDataType = {
  ministryName: string;
  insuranceType: string;
  description: string;
  status: number; // 1 for active, 0 for inactive
};

export const initialFormData: MasterFormDataType = {
  ministryName: "",
  insuranceType: "",
  description: "",
  status: 1, // Default to active
};
